<template lang="pug">
  div#id
    form(v-if="!account").margin-20
      .error(v-if="formerror") {{ formerror }}
      div.row
        div.col-md-6
          div.form-group
            label(for='username') Username
            input(type="text",
            v-model="loginModel.username"
            placeholder="Username")#username.form-control
        div.col-md-6
          div.form-group
            label(for='password') Password
            input(type="password",
            v-model="loginModel.password"
            placeholder="Password")#password.form-control

      div.row.text-center
        input(value="login",
        type="button",
        @click="login").btn.btn-primary

      div.row
        div.col-sm-12.text-center
          p(style="padding:0.5em") Having trouble logging in? Don't have an account?
            a(href="/contact") Let us know so we can help you


    div(v-else)

      div.row
        div.col-md-8
          div.info-block.order-information
            div.label Order information for:
            div.body {{ account.AccountName }}

          .info
            .info-block.customer-no
              .label Customer No.
              .body {{ account.AccountId }}

            .info-block.date-range
              .label Search orders by date or order number:
              .cols
                div.from
                  .search-label From:
                  datepicker(v-model="searchModel.from" format='dd/MM/yyyy' input-class="date-input")
                div.to
                  .search-label To:
                  datepicker(v-model="searchModel.to" format='dd/MM/yyyy'  input-class="date-input")
                div.or 
                  .search-label or
                div.ordernumber
                  .search-label Order Number:
                  input(type="text" v-model="searchModel.orderNumber")
                div.search
                  button.search(@click="search") Search &gt;

        .col-md-4
          .status
            //.status-codes
              .label Status codes:
              .codes
                span.strong R =
                span &nbsp;Received,
                span.strong &nbsp;B =
                span &nbsp;Batched,
                span.strong &nbsp;DB =
                span &nbsp;DeBatched,
                span.strong &nbsp;D =
                span &nbsp;Despatched,
                span.strong &nbsp;I =
                span &nbsp;Invoiced,
            .tracking-no
              .label Current Tracking No.
              .tracking {{ trackingNo }}         

      table.table.orders-table
        thead
          tr
            th Ordered
            th Fr No.
            th Order No.
            th Design
            th Colour Way
            th Mtrs/Roll
            //td Rolls
            th Tracking No.
            //th Job No.
            th Status
            th Treatment
            th Invoice Date
        tbody
          tr(v-for="order in orders",
          :key="JSON.stringify(order)")
            td {{ transformDate(order.date) }}
            td {{ order.frNo }}
            td {{ order.customerOrderNo }}
            td {{ order.design }}
            td {{ order.colourWay }}
            td {{ order.mtrs }}
            //td {{ valueFromObj(order['Roll No']) }}
            td {{ order.trackingNo }}
            //td {{ valueFromObj(order['Job No']) }}
            td {{ order.status }}
            td {{ order.treatment }}
            td {{ convertDate(order.invoice) }}
</template>

<script>
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js"

export default {
  name: 'app',
  components: { Datepicker },
  data () {
    return {
      loginModel: {
        username: '',
        password: ''
      },
      searchModel: {
        from: null,
        to: null,
        orderNumber: null
      },
      trackingNo: null,
      formerror: null
    }
  },

  watch: {
    'searchModel.from' (nv) {
      if (nv) this.$nextTick(() => { this.searchModel.orderNumber = null })
    },
    'searchModel.to' (nv) {
      if (nv) this.$nextTick(() => { this.searchModel.orderNumber = null })
    },
    'searchModel.orderNumber' (nv) {
      if (nv) {
        this.$nextTick(() => {
          this.searchModel.from = null
          this.searchModel.to = null
        })
      }
    },
    'orders' (nv, ov) {
      let o = [ ...(this.orders || []) ]
      let validOrders = o.sort((a, b) => (a.ordered > b.ordered) ? -1 : 1)
        .filter(order => order.trackingNo && order.status === 'DESPATCHED')
      // console.log(validOrders)
      this.trackingNo = (validOrders[0] && validOrders[0].trackingNo !== '') ? validOrders[0].trackingNo : 'no tracking no'
      return this
    }
  },

  computed: {
    account(){
      return this.$store.state.currentUser || null;
    },

    orders(){
      return this.$store.getters.orders
    }
  },

  methods: {
    login(){
      this.formerror = null
      if (this.loginModel.username && this.loginModel.password) {
        this.$store.dispatch('logIn', this.loginModel)
          .then(response=>{
            if (response && response.length > 0) {
              this.search()
            } else {
              // bad login
              this.formerror = 'Username or password incorrect'
            }
          }).catch(() => {
            this.formerror = 'Username or password incorrect'
          })
      } else {
        this.formerror = 'Username and password required'
      }
    },

    search () {
      this.$store.dispatch('loadOrders', { accountId: this.$store.state.currentUser.AccountId, ...this.searchModel })
    },

    // dates on the system count days from 1st Jan 1974
    // Convert a date supplied as TimeStamp into nice date string
    getDateFromTimeStamp (timeStamp, includeSeconds = true) {
      let date = new Date(timeStamp * 1000)
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
    },

    valueFromObj(obj){
      return(obj) ? obj[""] || '' : '';
    },

    transformDate (dateFromServer) {
      return this.getDateFromTimeStamp(dateFromServer)
    },

    convertDate (dateTime) {
      if (!dateTime || dateTime === '0') return '-'
      else return this.transformDate(dateTime)
    }
  },

  mounted(){
  }
}
</script>

<style lang="scss">
  $red: #eb2323;

  .strong { font-weight: 700 }

  .orders-table {
    thead {
      background: #CDCDCD;
      border-top:1px solid #999;

      tr > th {
        border-bottom:1px solid #999;
      }
    }
    tbody {
      border-top: none;
      background: white;

      tr{
        &:hover {
          background:#e8eff3;
          border:none;
        }
      }
    }

    tr {
      td, th {
        &:first-child { padding-left: 50px; }
        &:last-child { padding-right: 50px; }
      }
    }
  }

  .label {
    padding:0;
    font-weight: 700;
    font-size:0.9em;
    color: #575757;
  }

  .relative-container {
    display:block;
    position:relative;
    height: 162px;
  }

  .status {
    margin: 20px 0 ;
    .status-codes { 
      font-size: 13px;
    }
    .tracking-no {
      margin-top:10px;
      .tracking {
        display:block;
        border: 1px solid #CDCDCD;
        background: white;
        color:$red;
        padding:2px;
        font-size:1.2em;
      }
    }
  }

  .info {
    display: flex;
    width:100%;
    margin: 0 0 10px 0;
  }

  .info-block {
    .body {
      font-size:1.4em;
      color:$red;
    }

    &.customer-no {
      width: 150px;
    }
    

    &.date-range {
      flex: 1;
      .cols {
        display:flex;
        background:#AAA;
      
        input, .date-input { width: 90px; height: 25px; margin: 0 10px 5px 10px; }
        .search-label {
          color: white;
          font-size: 13px;
          text-align: center;
          vertical-align: middle;
          padding: 2px;
        }

        .from, .to, .ordernumber { width: 110px; }

        .or { margin-top: 20px; width: 20px; align-items: center; text-align: middle; height: 100%; color: white; }

        .search {
          flex: 1;
          text-align: right;
        }
        button.search {
          background: #777;
          font-weight: bold;
          color: white;
          border:none;
          height: 100%;
          padding: 0 20px;
          cursor: pointer;
          &:hover {
            background: #202f48;
          }
        }

      }
    }
  }

  .order-information {
    margin-bottom:30px;
  }

  .date-input { width: 90px !important; height: 25px !important; margin: 0 10px 5px 10px !important; }

</style>



// WEBPACK FOOTER //
// src/App.vue